"use client";
import { Row, Columns, Box } from "@dxp-feed/ui";
import {
  useAppDispatch,
  useAppSelector,
  useCallback,
  useEffect,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import { setPagecount } from "@/utils/redux/common/pagination";
// import { getAemData } from "@/utils/redux/productsListing/aemContentSlice/actions";
import { CLEAR_ALL_PRODUCT_ATTRIBUTES } from "@/utils/constant";
import SideBarTemplate from "../algolia/SideBarTemplate";
import { clearFilters, setSubcategory, setOriginalCategory } from "@/utils/redux/productsListing";
import { ProductGrid } from "./_components/ProductGrid";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import { setCurrentPage } from "@/utils/redux/ads";
import { PRODUCT_FILTERS } from "@/utils/constant";
import Loader from "@/components/Loader";
import {
  formatCategoryPartForURL,
  getAlcoholStoreFilter,
  // getOptionalFilters,
} from "@/helpers/productsFilterHelper";
import { setProductAemData } from "@/utils/redux/productsListing/aemContentSlice";
import { GlobalSearchResults } from "@/utils/types/algolia";
import { Product } from "@/utils/types/product";

interface ProductListingProps {
  text?: string;
  isSearchPage?: boolean;
  searchQuery?: string;
  disclaimerData?: Record<string, any>;
  preferredResults?: Product[];
}

const ProductListingMain = ({
  isSearchPage = false,
  searchQuery = "",
  disclaimerData,
  preferredResults
}: ProductListingProps) => {
  const [clicked, setClicked] = useState(false);
  const { subcategory, breadCrumb } = useAppSelector(
    (state) => state.productsSlice
  );
  const cartList: Record<string, any> = useAppSelector(
    (state) => state?.cartProductSlice
  );
  const { isLoading } = useAppSelector((state) => state.gigyaslice);

  const dispatch = useAppDispatch();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [isCatVisible, setIsCatVisible] = useState(false);
  const [isSortVisible, setIsSortVisible] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const pathname = usePathname();
  const toggleFilter = useCallback(
    () => setIsFilterVisible((prev) => !prev),
    []
  );
  const toggleCategory = () => setIsCatVisible((prev) => !prev);
  const toggleSort = () => setIsSortVisible((prev) => !prev);

  const closeSortHandler = useCallback(() => {
    setIsSortVisible(false);
  }, [setIsSortVisible]);
  useEffect(() => {
    if (isFilterVisible || isSortVisible || isCatVisible) {
      document.body.classList.add("noScroll");
    } else {
      document.body.classList.remove("noScroll");
    }
    return () => {
      document.body.classList.remove("noScroll");
    };
  }, [isFilterVisible, isSortVisible, isCatVisible]);

  const searchParams = useSearchParams();
  const urlParam = searchParams.get("tab");
  const router = useRouter();

  const { storeID, storeRegion } = useStoreDetails();

  useEffect(() => {
    dispatch(setSubcategory("All products"));
    dispatch(setPagecount(15));
    if (disclaimerData) {
      dispatch(setProductAemData(disclaimerData));
    }
    setIsInitialized(true);
    dispatch(clearFilters());
  }, [dispatch]);

  useEffect(() => {
    if (!isInitialized) return;
    if (
      subcategory !== "All products" &&
      (!urlParam || urlParam === "products") &&
      !isSearchPage
    ) {
      dispatch(setOriginalCategory(subcategory));
      const formattedSubcategory = formatCategoryPartForURL(subcategory);
      router.push(`/products/category/${formattedSubcategory}`);

     // router.push(`/products/category/${decodeURIComponent(subcategory)}`);
      setClicked(true);
    }
  }, [subcategory]);

  const filters = getAlcoholStoreFilter(storeID, storeRegion);
  // const optionalFilters = getOptionalFilters(cartList);

  return !clicked && storeID && !isLoading ? (
    <SideBarTemplate
      breadcrumbList={pathname === "/flyer" ? [] : breadCrumb}
      isUlVisible={isFilterVisible}
      isCatVisible={isCatVisible}
      closeCat={() => setIsCatVisible(false)}
      filterData={PRODUCT_FILTERS}
      closeUl={() => setIsFilterVisible(false)}
      isSortVisible={isSortVisible}
      closeSort={closeSortHandler}
      isSearchPage={isSearchPage}
      searchQuery={searchQuery}
      className={!searchQuery && isSearchPage ? `[&_.sideBar]:hidden` : ""}
      type="products"
      clearFilterAttributes={CLEAR_ALL_PRODUCT_ATTRIBUTES}
      filters={filters}
      pagePath="products"
      // optionalFilters={optionalFilters}
      preferredResults={preferredResults}
    >
      <Box as="div">
        <Box as="div" className="productMain">
          <Row>
            <Columns className="col-12 col-sm-12 col-lg-12 col-xl-12">
              <Box as="div" className="" role="contentinfo">
                <ProductGrid
                  isSearchPage={isSearchPage}
                  searchQuery={searchQuery}
                  toggleFilter={toggleFilter}
                  toggleCategory={toggleCategory}
                  toggleSort={toggleSort}
                />
              </Box>
            </Columns>
          </Row>
        </Box>
      </Box>
    </SideBarTemplate>
  ) : (
    <Loader className="w-full min-h-[300px] h-full inset-0 bg-[#fff] bg-opacity-70 z-[9999] flex items-center justify-center" />
  );
};

export default ProductListingMain;
